<template>
    <app-layout>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <brand-driver-values-form :countries="countries" />
            </div>
        </div>
    </app-layout>
</template>
<style>
    .modal {
        transition: opacity 0.25s ease;
    }
</style>
<script>
    import AppLayout from '@/Layouts/AppLayout'
    import BrandDriverValuesForm from '@/components/BrandDriverValuesForm'

    export default {
        props: [
            'countries'
        ],
        components: {
            AppLayout,
            BrandDriverValuesForm
        }
    }
    
</script>
